module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tab', {
    attrs: {
      "items": _vm.tabItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "imagecollage"
    },
    slot: "imagecollage"
  }, [_c('div', {
    staticClass: "ic-toolbar"
  }, [_c('v-upload', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "beforeShow": true,
      "uploadApi": '/static/data/editorUpload.json'
    },
    on: {
      "before": _vm.onUpload
    }
  }, [_c('v-button', {
    staticStyle: {
      "position": "absolute"
    }
  }, [_vm._v("添加图片")])], 1), _vm._v(" "), _c('v-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "disabled": !_vm.images.length
    },
    on: {
      "click": _vm.downloadImage
    }
  }, [_vm._v("下载")]), _vm._v(" "), _c('v-button', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "disabled": !_vm.images.length
    },
    on: {
      "click": _vm.copyToClipboard
    }
  }, [_vm._v("复制到剪贴板")]), _vm._v(" "), (_vm.selectedId != null) ? _c('v-button', {
    staticStyle: {
      "margin-left": "5px"
    },
    on: {
      "click": _vm.deleteSelected
    }
  }, [_vm._v("删除选中")]) : _vm._e(), _vm._v(" "), (_vm.copyMsg) ? _c('span', {
    staticClass: "ic-copy-msg"
  }, [_vm._v(_vm._s(_vm.copyMsg))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ic-controls"
  }, [_c('span', {
    staticClass: "ic-label"
  }, [_vm._v("画布")]), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "width": "100px",
      "display": "inline-block"
    },
    attrs: {
      "options": _vm.presetOptions
    },
    on: {
      "change": _vm.onPresetChange
    },
    model: {
      value: (_vm.preset),
      callback: function($$v) {
        _vm.preset = $$v
      },
      expression: "preset"
    }
  }), _vm._v(" "), (_vm.preset === 'custom') ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.canvasWidth),
      expression: "canvasWidth",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "layui-input ic-input-num",
    attrs: {
      "type": "number",
      "min": "100",
      "max": "8000"
    },
    domProps: {
      "value": (_vm.canvasWidth)
    },
    on: {
      "change": _vm.updateCanvas,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.canvasWidth = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ic-unit"
  }, [_vm._v("×")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.canvasHeight),
      expression: "canvasHeight",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "layui-input ic-input-num",
    attrs: {
      "type": "number",
      "min": "100",
      "max": "8000"
    },
    domProps: {
      "value": (_vm.canvasHeight)
    },
    on: {
      "change": _vm.updateCanvas,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.canvasHeight = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ic-unit"
  }, [_vm._v("px")])] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "ic-label",
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v("背景")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bgColor),
      expression: "bgColor"
    }],
    staticClass: "ic-color",
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.bgColor)
    },
    on: {
      "change": _vm.renderCanvas,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bgColor = $event.target.value
      }
    }
  })], 2), _vm._v(" "), _c('div', {
    ref: "wrap",
    staticClass: "ic-canvas-wrap",
    class: {
      'ic-drag-over': _vm.dragOver
    },
    on: {
      "dragover": function($event) {
        $event.preventDefault();
        _vm.dragOver = true
      },
      "dragleave": function($event) {
        $event.preventDefault();
        _vm.dragOver = false
      },
      "drop": function($event) {
        $event.preventDefault();
        return _vm.onDrop($event)
      }
    }
  }, [_c('canvas', {
    ref: "canvas",
    staticClass: "ic-canvas",
    on: {
      "mousedown": _vm.onMouseDown,
      "mousemove": _vm.onMouseMove,
      "mouseup": _vm.onMouseUp,
      "mouseleave": _vm.onMouseUp,
      "touchstart": function($event) {
        $event.preventDefault();
        return _vm.onTouchStart($event)
      },
      "touchmove": function($event) {
        $event.preventDefault();
        return _vm.onTouchMove($event)
      },
      "touchend": _vm.onTouchEnd,
      "wheel": function($event) {
        $event.preventDefault();
        return _vm.onWheel($event)
      }
    }
  }), _vm._v(" "), (!_vm.images.length && !_vm.dragOver) ? _c('div', {
    staticClass: "ic-placeholder"
  }, [_vm._v("拖拽图片到此处、点击「添加图片」上传或 Ctrl+V 粘贴")]) : (_vm.dragOver) ? _c('div', {
    staticClass: "ic-placeholder ic-drag-hint"
  }, [_vm._v("释放以添加图片")]) : _vm._e()]), _vm._v(" "), (_vm.images.length) ? _c('div', {
    staticClass: "ic-layers"
  }, [_c('div', {
    staticClass: "ic-layers-title"
  }, [_vm._v("图层（点击选中）")]), _vm._v(" "), _c('div', {
    staticClass: "ic-layer-list"
  }, _vm._l((_vm.imagesReversed), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "ic-layer-item",
      class: {
        'ic-layer-active': item.id === _vm.selectedId
      },
      on: {
        "click": function($event) {
          _vm.selectImage(item.id)
        }
      }
    }, [_c('img', {
      staticClass: "ic-layer-thumb",
      attrs: {
        "src": item.src
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "ic-layer-idx"
    }, [_vm._v(_vm._s(_vm.images.length - index))])])
  }))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-38a437a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/imagecollage.vue
// module id = 588
// module chunks = 2